(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('dose-form', {
                parent: 'entity',
                url: '/dose-form',
                data: {
                    authorities: [],
                    pageTitle: 'DoseForms'
                },
                ncyBreadcrumb: {
                    label: 'Dose Forms'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/dose-form/list/dose-form.html',
                        controller: 'DoseFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_DOSE_FORM];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_DOSE_FORM, access);
                }]
            });
    }
})();
